const enGBFormatter = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

export const formatDate = (date) => {
  if (date === null || date === undefined || date === "") {
    return "N/A";
  }

  try {
    const d = date instanceof Date ? date : new Date(date);

    if (isNaN(d.getTime())) {
      return "N/A";
    }

    return enGBFormatter.format(d).replace(",", "");
  } catch (error) {
    return "N/A";
  }
};
